define("settings/utils/plan-score/tables", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.TIER_TO_PLAN_TYPE = _exports.TIER_RANK = _exports.TERM_PRECEDENCE = _exports.ROLE_FLOOR = _exports.PROFILE_POINTS = _exports.GOAL_FLOOR = _exports.BASE_TIER_BY_POINTS = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /** The total order that makes `max()` over the three terms meaningful. */
  const TIER_RANK = _exports.TIER_RANK = {
    starter: 0,
    growth: 1,
    scale: 2
  };

  /**
   * Role floor (Q1) — transcribed from the revised table, Figma node `33781-596`, which supersedes
   * the Q1 table inside the scoring frame (`33684-74010`). That frame listed in-house among the
   * floorless roles and its partial-logic prose still says "agency/multi-client" in four places;
   * both are stale.
   *
   * The five keys come from the Q1 question frame (`33689-82987`), the answer list the user
   * actually sees. It has no "solo marketer" option, so the floored/floorless split lands exactly
   * on `33781-596`'s three roles and two, and it labels the freelance role
   * *Freelancer/Consultant* — hence `freelance_consultant` rather than the earlier `multi_client`.
   */
  const ROLE_FLOOR = _exports.ROLE_FLOOR = {
    own_business: undefined,
    in_house_team: 'growth',
    freelance_consultant: 'growth',
    agency: 'growth',
    other: undefined
  };

  /** Points earned per profile-count band (Q2). */

  /**
   * The 51+ band's "(+ Social Sets)" annotation selects no different plan — 51+ recommends the
   * same tier as 21–50. Anything wanting that signal reads `answers.profiles === '51_plus'`.
   */
  const PROFILE_POINTS = _exports.PROFILE_POINTS = {
    '1': 0,
    '2_5': 1,
    '6_20': 2,
    '21_50': 3,
    '51_plus': 4
  };

  /** `0–1 pts -> Starter` · `2 pts -> Growth` · `3–4 pts -> Scale` */
  const BASE_TIER_BY_POINTS = _exports.BASE_TIER_BY_POINTS = {
    0: 'starter',
    1: 'starter',
    2: 'growth',
    3: 'scale',
    4: 'scale'
  };

  /** Goal floor (Q3) — only applies when Q3 is answered. */
  const GOAL_FLOOR = _exports.GOAL_FLOOR = {
    plan_publish: undefined,
    measure_report: undefined,
    collaborate_approve: 'growth',
    respond_messages: 'growth',
    compare_competitors: 'scale'
  };
  const TIER_TO_PLAN_TYPE = _exports.TIER_TO_PLAN_TYPE = {
    starter: 'starter202506',
    growth: 'growth202506',
    scale: 'scale202506'
  };

  /**
   * Tie-break order for `winningTerm`, a copy decision rather than a logic one:
   * *"because you want to collaborate on approvals"* beats *"because you're an agency"* beats
   * *"because you have 12 profiles."*
   */
  const TERM_PRECEDENCE = _exports.TERM_PRECEDENCE = ['goal_floor', 'role_floor', 'base_points'];
});